<template>
  <div class="letter_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('notice.message') }}
      </div>
    </div>
    <div class="msg_num">
      <!-- <div class="all_msg"><span>{{data.ok_read_num}}</span>{{$t('notice.unRead')}}</div>
			<div class="read">全部标为已读</div> -->
    </div>
    <div class="msg_box">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <div
        v-for="item in data.list"
        v-if="!empty"
        class="item"
        @click="$router.push('/notice/'+item.id)"
      >
        <div class="tit">
          <p class="tips van-ellipsis">
            <span
              v-if="item['status']==0"
              style="color: red;"
            >
              <van-icon
                name="warning-o"
                size="16"
                color="red"
              />
            </span>
            {{ item[title] }}
          </p>
          <p class="time">
            {{ item.add_time }}
          </p>
        </div>
        <div
          class="content van-multi-ellipsis--l2"
          v-html="item[content]"
        />
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
	
	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	export default {
		name: "Login",
		data() {
			return {
				title:"title_"+ (this.$i18n.locale||"zh_cn"),
				content:"content_"+ (this.$i18n.locale||"zh_cn"),
				empty:false,
				data: {},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/notice').then((r) => {
					this.data = r.data;
					r.data.list.length == 0 ?
						(this.empty = true) :
						(this.empty = false);
				});
			},
		}
	};
</script>

<style lang="less" scoped>
	
	.msg_num{
		width:100%;
		height:20px;
		display: flex;
		justify-content: space-between;
		padding: 0 11px 0 20px;
		align-items: center;
		overflow: hidden;
		.all_msg{
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: bold;
			span{
				color: #F03041;
			}
		}
		.read{
			font-size: 12px;
			color: #3D96FF;
		}
	}
	.msg_box{
		width: 96%;
		margin-left: 2%;
		border-radius: 5px;
		background:rgba(255,255,255,1);
		padding: 0 13px 0 20px;
		box-shadow:0px 2px 9px 2px rgba(160,160,160,0.15);
		
		.item{
			padding: 10px 0 13px 0;
			border-bottom: 1px solid #ECECEC;
			&:last-of-type{
				border-bottom: none;
			}
			.tit{
				display: flex;
				justify-content: space-between;
				align-items: center;
				.tips{
					font-size: 14px;
                    flex: 1;
					line-height: 20px;
					color: rgba(0,0,0,.8);
					font-weight: bold;
				}
				.time{
                    flex: 1;
                    text-align: right;
					font-size: 12px;
					color: rgba(0,0,0,.6);
				}
			}
			.content{
				height: 36px;
				margin-top: 2px;
				line-height: 18px;
				font-size: 13px;
				color: rgba(0,0,0,.6);
			}
		}
	}

	/* Notifications share the account-centre's light, card-based hierarchy. */
	.letter_wrap {
		min-height: 100vh;
		padding-bottom: 1.2rem;
		box-sizing: border-box;
		background: url('../images/shop2/2.png') no-repeat top;
	}

	.red_top_bg {
		height: 50px;
		border-bottom: 1px solid rgba(235, 235, 235, .82);
		background: rgba(255, 255, 255, .86);
		color: #222;
		backdrop-filter: blur(10px);
	}

	.big_tit {
		top: 13px;
		color: #222;
		font-size: 16px;
		font-weight: 700;
	}

	.back_left {
		position: relative;
		width: 44px;
		height: 50px;
		margin: 0;
		background: none;
	}

	.back_left::after {
		position: absolute;
		top: 18px;
		left: 17px;
		width: 11px;
		height: 11px;
		border-bottom: 2px solid #484848;
		border-left: 2px solid #484848;
		content: '';
		transform: rotate(45deg);
	}

	.msg_num {
		height: 12px;
	}

	.msg_box {
		width: calc(100% - 24px);
		min-height: 120px;
		padding: 0 16px;
		margin: 12px auto 0;
		border: 1px solid #ebebeb;
		border-radius: 18px;
		background: rgba(255, 255, 255, .95);
		box-sizing: border-box;
		box-shadow: none;
	}

	.msg_box .item {
		padding: 16px 0;
		border-bottom-color: #f0f0f0;
	}

	.msg_box .item .tit .tips {
		color: #222;
		font-size: 14px;
	}

	.msg_box .item .tit .time,
	.msg_box .item .content {
		color: #717171;
	}

	/deep/ .van-empty {
		background: transparent;
	}
</style>
